import { render, staticRenderFns } from "./fsk18.vue?vue&type=template&id=1355e065&scoped=true&"
import script from "./fsk18.vue?vue&type=script&lang=js&"
export * from "./fsk18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355e065",
  null
  
)

export default component.exports